import { render, staticRenderFns } from "./ThousandVideo.vue?vue&type=template&id=559661b8&scoped=true&"
import script from "./ThousandVideo.vue?vue&type=script&lang=ts&"
export * from "./ThousandVideo.vue?vue&type=script&lang=ts&"
import style0 from "./ThousandVideo.vue?vue&type=style&index=0&id=559661b8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559661b8",
  null
  
)

export default component.exports